// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"aaf83cf2","667":"9d72442f","977":"7f35fc99"}[chunkId] + ".chunk.js";
};